import React, { Component } from 'react';
import Liste from './components/liste/Liste';
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Detail from './components/detail/Detail';

class App extends Component {



  render() {
    const type = "Primo"; // window.type_app && window.type_app==="Primo"?"Primo":"Selection";

    return (
      <Router>
        <Routes>
          <Route exact path="/" element={<Liste type={type} />} />
          <Route exact path="/tab/:tab" element={<Liste type={type} />} />
          <Route path="/detail/:tab/:monument/:ordre" element={<Detail type={type} />} />
        </Routes>
      </Router>
    );
  }
}

export default App;
